import { parseScopeParams } from '../../utils/scopeSelection';

const pad = (value) => String(Math.abs(value)).padStart(2, '0');

/** Date → ISO с локальным offset (без миллисекунд). Тот же формат, что toIsoWithOffset. */
export const formatIsoWithOffset = (date) => {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const offset = `${sign}${pad(Math.trunc(offsetMinutes / 60))}:${pad(offsetMinutes % 60)}`;
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${offset}`
  );
};

export const PRESETS = [
  { id: 'today', label: 'Сегодня' },
  { id: 'yesterday', label: 'Вчера' },
  { id: '7d', label: '7 дней' },
  { id: '30d', label: '30 дней' },
  { id: 'month', label: 'Этот месяц' },
  { id: 'prev_month', label: 'Прошлый месяц' },
  { id: 'custom', label: 'Произвольный' },
];
export const DEFAULT_PRESET = '7d';

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
const DAY_MS = 86400000;

/**
 * ТЗ №1 §6.5 Presets v1. Rolling — N×24h от now; календарные — локальные
 * границы дня/месяца. Граница запроса — явное намерение пользователя,
 * поэтому здесь timezone браузера допустима (в отличие от camera-bound данных).
 */
export const resolvePresetRange = (presetId, now = new Date()) => {
  switch (presetId) {
    case 'today':
      return { from: formatIsoWithOffset(startOfDay(now)), to: formatIsoWithOffset(now) };
    case 'yesterday': {
      const today = startOfDay(now);
      return { from: formatIsoWithOffset(new Date(today.getTime() - DAY_MS)), to: formatIsoWithOffset(today) };
    }
    case '7d':
      return { from: formatIsoWithOffset(new Date(now.getTime() - 7 * DAY_MS)), to: formatIsoWithOffset(now) };
    case '30d':
      return { from: formatIsoWithOffset(new Date(now.getTime() - 30 * DAY_MS)), to: formatIsoWithOffset(now) };
    case 'month':
      return { from: formatIsoWithOffset(startOfMonth(now)), to: formatIsoWithOffset(now) };
    case 'prev_month': {
      const thisMonth = startOfMonth(now);
      const prev = new Date(thisMonth.getFullYear(), thisMonth.getMonth() - 1, 1);
      return { from: formatIsoWithOffset(prev), to: formatIsoWithOffset(thisMonth) };
    }
    default:
      return null;
  }
};

export const isValidRange = (fromIso, toIso) => {
  const from = new Date(fromIso || '');
  const to = new Date(toIso || '');
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return false;
  return to.getTime() > from.getTime();
};

export const parseSummaryParams = (searchParams) => {
  const preset = searchParams.get('preset');
  return {
    // SCOPE-MULTI01: выбор объектов/локаций/камер/правил — массивы в URL;
    // legacy factory_id читается parseScopeParams как один объект.
    scope: parseScopeParams(searchParams),
    preset: PRESETS.some((p) => p.id === preset) ? preset : DEFAULT_PRESET,
    from: searchParams.get('from') || '',
    to: searchParams.get('to') || '',
  };
};
